import { z } from 'zod';

export const createSchoolYearSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  administrativeStartDate: z.string().min(1, 'Start date is required'),
  administrativeEndDate: z.string().min(1, 'End date is required'),
  reenrollmentStartDate: z.string().optional().or(z.literal('')),
  openEnrollmentStartDate: z.string().optional().or(z.literal('')),
});

export type CreateSchoolYearFormValues = z.infer<typeof createSchoolYearSchema>;

export const defaultFormValues: CreateSchoolYearFormValues = {
  name: '',
  administrativeStartDate: '',
  administrativeEndDate: '',
  reenrollmentStartDate: '',
  openEnrollmentStartDate: '',
};
